import endpoints from "@services/endpoints";
import exportApi from "@services/exports";
import { useToast } from "@common/composable/toast";
import { useI18n } from "vue-i18n";
import { useFiles } from "@common/composable/useFiles";

export function useDownload() {
  const { createToast, closeToast } = useToast();
  const { t: $t } = useI18n();
  const { triggerFileDownloadViaEndpoint } = useFiles();

  const downloadExportByRunID = async (exportRunId: string): Promise<void> => {
    try {
      createToast({
        text: $t("Zipping"),
        title: $t("PrepareDownload"),
        id: "toast_from_download_export",
        variant: "primary",
        titleIcon: "Export",
        textIllustration: "Export",
        statusTextIcon: "XCircleSolid"
      });

      await exportApi.prepareForDownload(exportRunId);

      closeToast("toast_from_download_export");
      triggerFileDownloadViaEndpoint(endpoints.exports.download, {
        exportRunId: exportRunId
      });
    } catch (error: any) {
      if (error && error.isAxiosError) {
        if (error.response.status === 409) {
          createToast({
            text: $t("api.errors." + error.response.data.error) ?? error.response.data.error,
            title: $t("Error"),
            variant: "danger",
            titleIcon: "Export",
            textIllustration: "Export",
            statusTextIcon: "XCircleSolid"
          });
        }
      }
    }
  };
  return { downloadExportByRunID };
}

export function getLiveLogStreamName(module: string) {
  switch (module) {
    case "exports":
    case "imports":
      return "GetExportImportLogs";
    default:
      return "";
  }
}
